<app-pd-collect-data
  *ngIf="cs.showForm$ | async"
  [hash]="$any(cs.clientHash$ | async)"
  [sellerInfo]="$any(cs.sellerInfo$ | async)"
  [showProceedButton]="false"
></app-pd-collect-data>
